module.exports = __webpack_public_path__ + "img/post-1.f97081bc.jpg";